export default __webpack_public_path__ + "static/media/cel1.90f9a1b9.png";